import GoogleSearch from './google-search';
import BingSearch from './bing-search';

export function initProvider(config) {
	const searchProvider = config.provider;
	switch (searchProvider) {
		case 'bing':
			return new BingSearch(config);
		default:
			return new GoogleSearch(config);
	}
}
